import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {FabricPositionalParams} from '@Utils/fabric.util';
import type {ItemMenuOpenSource} from '@Libraries/ga-events';
import type {PopupAnchorRect} from './poster-popup-menu.types';

interface StateProps {
  openPosterPopUpMenu: boolean;
  popUpPosition: FabricPositionalParams | undefined;
  target: any | undefined;
  eventCanvasOffset: FabricPositionalParams | undefined;
  /** Set when the menu opens from a right-click on the empty timeline area; routes to a paste-only menu instead of the full canvas menu (both have an undefined target). */
  isTimelineContextMenu?: boolean;
  /** Set when the menu opens from a right-click on a timeline item bar (not the canvas). Gates timeline-only actions like Split. */
  isTimelineItemContextMenu?: boolean;
  /** Set when the menu drops from a control (the on-canvas action bar's More button) instead of a right-click point. */
  anchorRect?: PopupAnchorRect | null;
  /** How the menu was opened, sent with each option click (Editor_Item_Menu_Option_Clicked). */
  openSource?: ItemMenuOpenSource | null;
}

const initialState: StateProps = {
  openPosterPopUpMenu: false,
  popUpPosition: undefined,
  target: undefined,
  eventCanvasOffset: undefined,
  isTimelineContextMenu: false,
  isTimelineItemContextMenu: false,
  anchorRect: null,
  openSource: null,
};

const PosterPopUpMenu = createSlice({
  name: 'PosterPopUpMenu',
  initialState,
  reducers: {
    updatePopUpStateAndPosition: (state: StateProps, action: PayloadAction<StateProps>) => {
      state.openPosterPopUpMenu = action.payload.openPosterPopUpMenu;
      state.popUpPosition = action.payload.popUpPosition;
      state.target = action.payload.target;
      state.eventCanvasOffset = action.payload.eventCanvasOffset;
      state.isTimelineContextMenu = action.payload.isTimelineContextMenu ?? false;
      state.isTimelineItemContextMenu = action.payload.isTimelineItemContextMenu ?? false;
      state.anchorRect = action.payload.anchorRect ?? null;
      state.openSource = action.payload.openSource ?? null;
    },
  },
});

export const {updatePopUpStateAndPosition} = PosterPopUpMenu.actions;
export const PosterPopUpMenuReducer = PosterPopUpMenu.reducer;
